import { ModalController } from '@ionic/angular';
import { Component, OnDestroy, OnInit } from '@angular/core';

/**
 * Setting gift component
 */
@Component({
  selector: 'app-setting-gift',
  templateUrl: './setting-gift.component.html',
  styleUrls: ['./setting-gift.component.scss'],
})
export class SettingGiftComponent implements OnInit, OnDestroy {

  /**
   * Constructor
   */
  constructor(
    private modalController: ModalController,
  ) { }

  ngOnInit() {}

  ngOnDestroy(): void {
  }

  /**
   * Dismiss checkin setting modal
   */
  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { modal.dismiss(); }
    }
  }

}
